import { combineReducers } from "redux";
import {users} from "./userReducer";
import {shops} from './shopReducer'
import {stories} from './storyReducer'

const statisticsReducer = combineReducers({users,shops,stories});

export default statisticsReducer;